module.exports = __webpack_public_path__ + "static/media/default_avatar.19566338.svg";